function nebulaApplySelectedCondition(root, radio){
  if(!root || !radio) return;
  const label = radio.getAttribute('data-condition-label') || '';
  if(!label) return;
  root.querySelectorAll('[data-nebula-about-condition]').forEach(function(node){ node.textContent = label; });
  root.querySelectorAll('[data-nebula-product-description] li, [data-nebula-product-description] p').forEach(function(node){
    const strong = node.querySelector('strong');
    if(!strong || !/^condition\s*:/i.test((strong.textContent || '').trim())) return;
    let cursor = strong.nextSibling;
    while(cursor){ const next=cursor.nextSibling; cursor.remove(); cursor=next; }
    node.appendChild(document.createTextNode(' ' + label));
  });
}


function nebulaUpdateWarrantyMessaging(root, conditionClass){
  if(!root) return;
  const supplier = conditionClass === 'brand';
  root.querySelectorAll('[data-ob-warranty-feature]').forEach(function(feature){
    feature.classList.toggle('is-supplier-warranty', supplier);
    const title = feature.querySelector('[data-ob-warranty-feature-title]');
    const copy = feature.querySelector('[data-ob-warranty-feature-copy]');
    if(title) title.textContent = supplier ? 'Manufacturer Warranty' : '24 Month OrbitBay Guarantee';
    if(copy) copy.textContent = supplier ? 'Included where applicable on Supplier New.' : 'Included on eligible OrbitBay Stock.';
  });
}

function nebulaPlacePurchaseBlock(root, radio){
  if(!root || !radio) return;
  const purchase = root.querySelector('[data-ob-buybox-purchase]');
  const option = radio.closest('.nebula-condition-option');
  const list = option && option.closest('.nebula-condition-list');
  if(!purchase || !option || !list) return;

  Array.from(list.children).forEach(function(child){
    if(!child.classList || !child.classList.contains('nebula-condition-option')) return;
    const shell = document.createElement('div');
    shell.className = 'ob-route-shell';
    list.insertBefore(shell, child);
    shell.appendChild(child);
  });

  const shells = Array.from(list.querySelectorAll(':scope > .ob-route-shell'));
  const routeOrder = function(node){
    if(node.classList.contains('nebula-condition-option--surplus')) return 10;
    if(node.classList.contains('nebula-condition-option--brand')) return 20;
    if(node.classList.contains('nebula-condition-option--like-new')) return 30;
    if(node.classList.contains('nebula-condition-option--open')) return 40;
    if(node.classList.contains('nebula-condition-option--refurb')) return 50;
    if(node.classList.contains('nebula-condition-option--sell')) return 90;
    return 80;
  };

  let selectedShell = option.parentElement;
  shells.forEach(function(shell){
    const route = shell.querySelector(':scope > .nebula-condition-option');
    if(!route) return;
    const selected = route === option;
    route.classList.toggle('is-ob-selected', selected);
    shell.classList.toggle('is-ob-selected-shell', selected);
    shell.style.setProperty('order', String(routeOrder(route)), 'important');
    route.style.removeProperty('order');
  });

  if(selectedShell && selectedShell.classList.contains('ob-route-shell')) selectedShell.appendChild(purchase);
  purchase.style.removeProperty('order');
}

function nebulaInstallGalleryImageFallbacks(scope){
  (scope || document).querySelectorAll('[data-nebula-gallery]').forEach(function(wrap){
    const main=wrap.querySelector('[data-nebula-main-image]');
    if(!main || main.dataset.nebulaFallbackReady==='1') return;
    main.dataset.nebulaFallbackReady='1';
    main.addEventListener('error',function(){
      const attempted=new Set(String(main.dataset.nebulaFailedSources||'').split('|').filter(Boolean));
      attempted.add(main.getAttribute('src')||'');
      main.dataset.nebulaFailedSources=[...attempted].join('|');
      const next=[...wrap.querySelectorAll('[data-nebula-thumb]')].find(function(thumb){
        const src=thumb.getAttribute('data-full')||'';return src && !attempted.has(src);
      });
      if(next){
        main.setAttribute('src',next.getAttribute('data-full'));
        main.setAttribute('alt',next.getAttribute('data-alt')||main.getAttribute('alt')||'Product image');
        wrap.querySelectorAll('[data-nebula-thumb]').forEach(t=>t.classList.remove('is-active'));
        next.classList.add('is-active');
      }
    });
  });
}

document.addEventListener('DOMContentLoaded',function(){ nebulaInstallGalleryImageFallbacks(document); });

document.addEventListener('click', function(event){
  const thumb = event.target.closest('[data-nebula-thumb]');
  if(thumb){
    const wrap = thumb.closest('[data-nebula-gallery]');
    const main = wrap && wrap.querySelector('[data-nebula-main-image]');
    const src = thumb.getAttribute('data-full');
    const alt = thumb.getAttribute('data-alt') || '';
    if(main && src){ main.setAttribute('src', src); main.setAttribute('alt', alt); }
    wrap.querySelectorAll('[data-nebula-thumb]').forEach(t => t.classList.remove('is-active'));
    thumb.classList.add('is-active');
  }
});

document.addEventListener('change', function(event){
  const radio = event.target.closest('[data-nebula-condition-radio]');
  if(!radio) return;
  const form = radio.closest('[data-nebula-product-form]');
  if(!form) return;
  const root = form.closest('.nebula-product') || document;
  const price = radio.getAttribute('data-variant-price');
  const exVat = radio.getAttribute('data-variant-ex-vat');
  const priceOutputs = root.querySelectorAll('[data-nebula-selected-price]');
  const exVatOutputs = root.querySelectorAll('[data-nebula-selected-ex-vat]');
  if(price) priceOutputs.forEach(function(node){ node.textContent = price; });
  if(exVat) exVatOutputs.forEach(function(node){ node.textContent = exVat + ' ex VAT'; });

  const sku = radio.getAttribute('data-variant-sku') || '';
  const skuRow = root.querySelector('[data-nebula-product-code-row]');
  const skuOutput = root.querySelector('[data-nebula-selected-sku]');
  if(skuOutput) skuOutput.textContent = sku;
  if(skuRow) skuRow.hidden = !sku;

  const available = radio.getAttribute('data-variant-available') !== '0' && !radio.disabled;
  const stockQty = parseInt(radio.getAttribute('data-variant-stock') || '0', 10);
  const stockLabel = root.querySelector('[data-nebula-stock-label]');
  const stockDot = root.querySelector('[data-nebula-stock-dot]');
  if(stockLabel) stockLabel.textContent = available ? (stockQty > 0 ? stockQty + ' In Stock' : 'In Stock') : 'Out of stock';
  if(stockDot) stockDot.classList.toggle('nebula-stock-dot--out', !available);
  root.querySelectorAll('[data-nebula-mobile-stock]').forEach(function(node){ node.textContent = available ? 'In stock' : 'Out of stock'; });
  root.querySelectorAll('[data-nebula-mobile-add]').forEach(function(node){ node.disabled = !available; });

  const conditionLabel = radio.getAttribute('data-condition-label') || '';
  const conditionClass = radio.getAttribute('data-condition-class') || '';
  const conditionHeading = root.querySelector('[data-ob-buybox-condition-heading]');
  if(conditionHeading && conditionLabel) conditionHeading.textContent = conditionLabel;
  const conditionIcon = radio.getAttribute('data-condition-icon') || '';

  /* v8.04: the selected buying option expands into the complete transaction card. */
  nebulaPlacePurchaseBlock(root, radio);

  /* Keep the clean purchase block in sync with the selected buying option. */
  const purchaseStock = root.querySelector('[data-ob-buybox-stock]');
  if(purchaseStock){
    purchaseStock.classList.toggle('is-out', !available);
    const stockCopy = purchaseStock.querySelector('strong');
    if(stockCopy){
      if(!available) stockCopy.textContent = 'Out of stock';
      else if(conditionClass === 'surplus' && stockQty > 0) stockCopy.textContent = stockQty + ' in stock · ready to dispatch';
      else if(conditionClass === 'surplus') stockCopy.textContent = 'Available';
      else if(conditionClass === 'brand') stockCopy.textContent = 'Available to order';
      else stockCopy.textContent = 'In stock';
    }
  }

  const savingWrap = root.querySelector('[data-ob-buybox-saving]');
  const savingValue = root.querySelector('[data-ob-buybox-save]');
  const compareValue = root.querySelector('[data-ob-buybox-compare-price]');
  const variantCents = parseInt(radio.getAttribute('data-variant-price-cents') || '0', 10);
  const supplierCents = parseInt(radio.getAttribute('data-supplier-price-cents') || '0', 10);
  const showSaving = conditionClass === 'surplus' && supplierCents > variantCents && variantCents > 0;
  if(savingWrap){
    savingWrap.hidden = !showSaving;
    if(showSaving){
      const pounds = function(cents){ return '£' + (cents / 100).toFixed(2); };
      if(compareValue) compareValue.textContent = pounds(supplierCents);
      if(savingValue) savingValue.textContent = 'Save ' + pounds(supplierCents - variantCents);
    }
  }

  const orbitbayDelivery = root.querySelector('[data-ob-purchase-orbitbay-delivery]');
  const supplierDelivery = root.querySelector('[data-ob-purchase-supplier-delivery]');
  if(orbitbayDelivery) orbitbayDelivery.hidden = conditionClass === 'brand';
  if(supplierDelivery) supplierDelivery.hidden = conditionClass !== 'brand';

  const guaranteeReassurance = root.querySelector('[data-ob-guarantee-reassurance]');
  if(guaranteeReassurance){
    if(conditionClass === 'brand') guaranteeReassurance.textContent = 'Manufacturer warranty included where applicable';
    else if(conditionClass === 'surplus') guaranteeReassurance.textContent = '24 Month OrbitBay Guarantee on eligible OrbitBay Stock';
    else guaranteeReassurance.textContent = 'Warranty or guarantee included where shown';
  }

  nebulaUpdateWarrantyMessaging(root, conditionClass);

  const conditionSpec = root.querySelector('[data-nebula-condition-spec]');
  if(conditionSpec){
    ['surplus','like-new','brand','open','refurb'].forEach(function(name){
      conditionSpec.classList.remove('nebula-spec--condition-' + name);
    });
    if(conditionClass) conditionSpec.classList.add('nebula-spec--condition-' + conditionClass);
  }
  const conditionTitle = root.querySelector('[data-nebula-condition-title]');
  if(conditionTitle && conditionLabel) conditionTitle.textContent = conditionLabel;
  const conditionRing = root.querySelector('[data-nebula-condition-ring]');
  if(conditionRing && conditionIcon) conditionRing.setAttribute('src', conditionIcon);
  nebulaApplySelectedCondition(root, radio);
});


document.addEventListener('change', function(event){
  const radio = event.target.closest('[data-nebula-condition-radio]');
  if(!radio) return;
  const form = radio.closest('[data-nebula-product-form]');
  if(!form) return;
  const add = form.querySelector('[data-nebula-add]');
  const buyNow = form.querySelector('.nebula-buy-now');
  const disabled = radio.disabled;
  if(add) add.disabled = disabled;
  if(buyNow) buyNow.disabled = disabled;
});


/* OrbitBay v7.13: initialise every shared condition label from the checked card. */
(function(){
  function initialise(scope){
    const root = scope?.matches?.('.nebula-product') ? scope : scope?.querySelector?.('.nebula-product');
    if(!root) return;
    const checked = root.querySelector('[data-nebula-condition-radio]:checked');
    if(checked){
      nebulaApplySelectedCondition(root, checked);
      nebulaPlacePurchaseBlock(root, checked);
      nebulaUpdateWarrantyMessaging(root, checked.getAttribute('data-condition-class') || '');
      const conditionHeading = root.querySelector('[data-ob-buybox-condition-heading]');
      const conditionLabel = checked.getAttribute('data-condition-label') || '';
      if(conditionHeading && conditionLabel) conditionHeading.textContent = conditionLabel;
    }
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',function(){ document.querySelectorAll('.nebula-product').forEach(initialise); });
  else document.querySelectorAll('.nebula-product').forEach(initialise);
  document.addEventListener('shopify:section:load',function(event){ initialise(event.target); });
})();

/* OrbitBay v7.02 structured conditions + New / Supplier New public naming */
(function(){
  function setText(node, value){ if(node && node.textContent !== value) node.textContent = value; }
  function normaliseConditionCards(scope){
    const root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('.nebula-product .nebula-condition-option').forEach(function(option){
      const radio = option.querySelector('[data-nebula-condition-radio]');
      if(!radio) return;
      const heading = option.querySelector('h3');
      const title = (heading?.textContent || '').toLowerCase();
      const type = (radio.getAttribute('data-condition-class') || '').toLowerCase();
      const summary = option.querySelector('.ob-condition-summary');
      const guarantee = option.querySelector('.ob-condition-guarantee span');
      const benefit = option.querySelector('.ob-condition-benefit strong');
      const benefitRow = option.querySelector('.ob-condition-benefit');
      if(summary) summary.hidden = false;
      if(benefitRow) benefitRow.hidden = false;
      if(type === 'surplus'){
        setText(heading,'New'); setText(summary,'Brand new and unused.'); setText(guarantee,'24 Month OrbitBay Guarantee included.'); setText(benefit,'Sold directly by OrbitBay.');
      }else if(type === 'like-new' || title.includes('open box')){
        setText(heading,'Like New'); setText(summary,'Opened, inspected or returned · Specific condition shown on the listing'); setText(guarantee,'Warranty or guarantee included where shown.'); setText(benefit,'Condition details shown before purchase.');
      }else if(type === 'brand'){
        setText(heading,'Supplier New'); setText(summary,'New stock sourced through our UK supplier network.'); setText(guarantee,'Manufacturer warranty where applicable.'); setText(benefit,'Sold by OrbitBay; a UK distribution partner may fulfil the order.');
      }else if(type === 'refurb'){
        if(title.includes('excellent')){ setText(heading,'Refurbished - Excellent'); setText(summary,'Professionally tested · Minimal signs of use'); setText(benefit,'Excellent condition. Better value.'); }
        else if(title.includes('very good')){ setText(heading,'Refurbished - Very Good'); setText(summary,'Professionally tested · Light signs of use'); setText(benefit,'Reliable technology. Better value.'); }
        else { setText(heading,'Refurbished - Good'); setText(summary,'Professionally tested · Visible cosmetic wear'); setText(benefit,'Fully functional. Best refurbished value.'); }
        setText(guarantee,'Warranty or guarantee included where shown.');
      }
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',function(){ normaliseConditionCards(document); }); else normaliseConditionCards(document);
  document.addEventListener('shopify:section:load',function(event){ normaliseConditionCards(event.target); });
  const observer=new MutationObserver(function(mutations){ for(const mutation of mutations){ for(const node of mutation.addedNodes){ if(node&&node.nodeType===1&&(node.matches?.('.nebula-condition-option, .nebula-product')||node.querySelector?.('.nebula-condition-option'))){ normaliseConditionCards(node.matches?.('.nebula-condition-option')?node.parentElement:node); return; } } } });
  observer.observe(document.documentElement,{childList:true,subtree:true});
})();

/* OrbitBay v8.00 — compact UK delivery countdown for eligible OrbitBay-stock cards (4pm cut-off). */
(function(){
  const TIME_ZONE = 'Europe/London';
  const zonedPartsFormatter = new Intl.DateTimeFormat('en-GB', {
    timeZone: TIME_ZONE,
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
    hourCycle: 'h23'
  });
  const dayMonthFormatter = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'UTC', day: 'numeric', month: 'short'
  });
  const fullDateFormatter = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'short'
  });

  function zonedParts(date){
    const values = {};
    zonedPartsFormatter.formatToParts(date).forEach(function(part){
      if(part.type !== 'literal') values[part.type] = Number(part.value);
    });
    return values;
  }

  function wallDateToUtc(parts){
    const desired = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour || 0, parts.minute || 0, parts.second || 0);
    let guess = desired;
    for(let i = 0; i < 4; i += 1){
      const actual = zonedParts(new Date(guess));
      const actualWall = Date.UTC(actual.year, actual.month - 1, actual.day, actual.hour, actual.minute, actual.second);
      const adjustment = desired - actualWall;
      guess += adjustment;
      if(adjustment === 0) break;
    }
    return new Date(guess);
  }

  function addWallDays(parts, amount){
    const date = new Date(Date.UTC(parts.year, parts.month - 1, parts.day + amount, 12));
    return { year: date.getUTCFullYear(), month: date.getUTCMonth() + 1, day: date.getUTCDate() };
  }

  function wallDayOfWeek(parts){
    return new Date(Date.UTC(parts.year, parts.month - 1, parts.day, 12)).getUTCDay();
  }

  function nextDeliveryWindow(now){
    const current = zonedParts(now);
    const today = { year: current.year, month: current.month, day: current.day };

    for(let offset = 0; offset <= 8; offset += 1){
      const cutoffDate = addWallDays(today, offset);
      const weekday = wallDayOfWeek(cutoffDate);
      // Merchant/shipping promise is Monday-Friday only. Weekend orders begin
      // processing on the next working day; there is no Saturday cut-off.
      if(weekday === 0 || weekday === 6) continue;

      const cutoffHour = 16;
      const cutoff = wallDateToUtc({
        year: cutoffDate.year,
        month: cutoffDate.month,
        day: cutoffDate.day,
        hour: cutoffHour,
        minute: 0,
        second: 0
      });
      if(cutoff.getTime() <= now.getTime()) continue;

      // Friday orders before 4pm are estimated for Monday; Mon-Thu are
      // estimated for the following working day.
      const deliveryOffset = weekday === 5 ? 3 : 1;

      return {
        cutoff: cutoff,
        delivery: addWallDays(cutoffDate, deliveryOffset),
        today: today
      };
    }
    return null;
  }

  function wallDateNumber(parts){
    return Date.UTC(parts.year, parts.month - 1, parts.day);
  }

  function deliveryLabel(windowData){
    const deliveryDate = new Date(Date.UTC(windowData.delivery.year, windowData.delivery.month - 1, windowData.delivery.day, 12));
    const dayDifference = Math.round((wallDateNumber(windowData.delivery) - wallDateNumber(windowData.today)) / 86400000);
    if(dayDifference === 1) return 'Tomorrow, ' + dayMonthFormatter.format(deliveryDate);
    return fullDateFormatter.format(deliveryDate);
  }

  function countdownLabel(milliseconds){
    let totalMinutes = Math.max(0, Math.ceil(milliseconds / 60000));
    const days = Math.floor(totalMinutes / 1440);
    totalMinutes -= days * 1440;
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes - (hours * 60);
    const parts = [];
    if(days) parts.push(days + 'd');
    if(hours || days) parts.push(hours + 'h');
    parts.push(minutes + 'm');
    return parts.join(' ');
  }

  function updateDeliveryCountdowns(scope){
    const root = scope && scope.querySelectorAll ? scope : document;
    const countdowns = root.querySelectorAll('[data-orbitbay-delivery-countdown]');
    if(!countdowns.length) return;

    const now = new Date();
    const windowData = nextDeliveryWindow(now);
    if(!windowData) return;

    const dateText = deliveryLabel(windowData);
    const timeText = countdownLabel(windowData.cutoff.getTime() - now.getTime());
    countdowns.forEach(function(node){
      const dateNode = node.querySelector('[data-ob-delivery-date]');
      const timeNode = node.querySelector('[data-ob-delivery-time]');
      if(dateNode) dateNode.textContent = dateText;
      if(timeNode) timeNode.textContent = timeText;
    });
  }

  function startDeliveryCountdown(scope){
    updateDeliveryCountdowns(scope || document);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ startDeliveryCountdown(document); });
  }else{
    startDeliveryCountdown(document);
  }

  window.setInterval(function(){ updateDeliveryCountdowns(document); }, 30000);
  document.addEventListener('visibilitychange', function(){
    if(!document.hidden) updateDeliveryCountdowns(document);
  });
  document.addEventListener('shopify:section:load', function(event){ updateDeliveryCountdowns(event.target); });
})();

/* OrbitBay v7.36 — local wishlist and product-sharing dialogs. */
(function(){
  const STORAGE_KEY = 'orbitbayWishlist';

  function readWishlist(){
    try{
      const value = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(value) ? value : [];
    }catch(error){
      return [];
    }
  }

  function writeWishlist(items){
    try{ window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); }
    catch(error){ /* Storage can be blocked; the current modal still works. */ }
  }

  function openDialog(dialog){
    if(!dialog) return;
    if(typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open','');
  }

  function closeDialog(dialog){
    if(!dialog) return;
    if(typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  }

  function currentProduct(button){
    const root = button.closest('.nebula-product') || document;
    const displayedPrice = root.querySelector('[data-nebula-selected-price]');
    const currentImage = root.querySelector('[data-nebula-main-image]');
    return {
      id: String(button.getAttribute('data-product-id') || ''),
      title: button.getAttribute('data-product-title') || document.title,
      url: button.getAttribute('data-product-url') || window.location.href,
      image: currentImage?.currentSrc || currentImage?.src || button.getAttribute('data-product-image') || '',
      price: displayedPrice?.textContent?.trim() || ''
    };
  }

  function updateWishlistButtons(scope){
    const items = readWishlist();
    const ids = new Set(items.map(function(item){ return String(item.id); }));
    (scope || document).querySelectorAll('[data-ob-wishlist-button]').forEach(function(button){
      const saved = ids.has(String(button.getAttribute('data-product-id') || ''));
      button.classList.toggle('is-saved', saved);
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
      const label = button.querySelector('[data-ob-wishlist-label]');
      if(label) label.textContent = saved ? 'View Wishlist' : 'Add to Wishlist';
    });
  }

  function renderWishlist(dialog){
    const list = dialog?.querySelector('[data-ob-wishlist-list]');
    if(!list) return;
    const items = readWishlist();
    list.replaceChildren();
    if(!items.length){
      const empty = document.createElement('p');
      empty.className = 'ob-wishlist-empty';
      empty.textContent = 'Your wishlist is empty. Add a product and it will appear here.';
      list.appendChild(empty);
      return;
    }
    items.forEach(function(item){
      const row = document.createElement('article');
      row.className = 'ob-wishlist-item';

      const image = document.createElement('img');
      image.src = item.image || '';
      image.alt = '';
      image.loading = 'lazy';

      const copy = document.createElement('div');
      copy.className = 'ob-wishlist-item__copy';
      const link = document.createElement('a');
      link.href = item.url || '#';
      link.textContent = item.title || 'Saved product';
      const price = document.createElement('span');
      price.textContent = item.price || '';
      copy.append(link, price);

      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'ob-wishlist-item__remove';
      remove.textContent = 'Remove';
      remove.setAttribute('data-ob-remove-wishlist', String(item.id || ''));

      row.append(image, copy, remove);
      list.appendChild(row);
    });
  }

  function configureShareDialog(dialog, button){
    const title = button.getAttribute('data-share-title') || document.title;
    const url = button.getAttribute('data-share-url') || window.location.href;
    const encodedUrl = encodeURIComponent(url);
    const encodedTitle = encodeURIComponent(title);
    const encodedMessage = encodeURIComponent(title + ' – ' + url);
    const destinations = {
      whatsapp: 'https://wa.me/?text=' + encodedMessage,
      facebook: 'https://www.facebook.com/sharer/sharer.php?u=' + encodedUrl,
      x: 'https://twitter.com/intent/tweet?text=' + encodedTitle + '&url=' + encodedUrl,
      linkedin: 'https://www.linkedin.com/sharing/share-offsite/?url=' + encodedUrl,
      email: 'mailto:?subject=' + encodedTitle + '&body=' + encodedMessage
    };
    dialog.querySelectorAll('[data-ob-share-option]').forEach(function(link){
      const destination = destinations[link.getAttribute('data-ob-share-option')];
      if(destination) link.setAttribute('href', destination);
    });
    const copy = dialog.querySelector('[data-ob-copy-link]');
    if(copy) copy.setAttribute('data-copy-url', url);
  }

  document.addEventListener('click', function(event){
    const wishlistButton = event.target.closest('[data-ob-wishlist-button]');
    if(wishlistButton){
      const product = currentProduct(wishlistButton);
      let items = readWishlist();
      if(!items.some(function(item){ return String(item.id) === product.id; })){
        items.unshift(product);
        writeWishlist(items.slice(0, 40));
      }
      const root = wishlistButton.closest('.nebula-product') || document;
      const dialog = root.querySelector('[data-ob-wishlist-dialog]');
      updateWishlistButtons(document);
      renderWishlist(dialog);
      openDialog(dialog);
      return;
    }

    const removeButton = event.target.closest('[data-ob-remove-wishlist]');
    if(removeButton){
      const id = String(removeButton.getAttribute('data-ob-remove-wishlist') || '');
      writeWishlist(readWishlist().filter(function(item){ return String(item.id) !== id; }));
      const dialog = removeButton.closest('[data-ob-wishlist-dialog]');
      renderWishlist(dialog);
      updateWishlistButtons(document);
      return;
    }

    const shareButton = event.target.closest('[data-ob-share-button]');
    if(shareButton){
      const root = shareButton.closest('.nebula-product') || document;
      const dialog = root.querySelector('[data-ob-share-dialog]');
      configureShareDialog(dialog, shareButton);
      openDialog(dialog);
      return;
    }

    const copyButton = event.target.closest('[data-ob-copy-link]');
    if(copyButton){
      const url = copyButton.getAttribute('data-copy-url') || window.location.href;
      const label = copyButton.querySelector('[data-ob-copy-label]');
      const finish = function(){
        if(label) label.textContent = 'Link copied';
        window.setTimeout(function(){ if(label) label.textContent = 'Copy product URL'; }, 1800);
      };
      if(navigator.clipboard && window.isSecureContext){
        navigator.clipboard.writeText(url).then(finish).catch(function(){});
      }else{
        const input = document.createElement('textarea');
        input.value = url;
        input.setAttribute('readonly','');
        input.style.position = 'fixed';
        input.style.opacity = '0';
        document.body.appendChild(input);
        input.select();
        try{ document.execCommand('copy'); finish(); }catch(error){}
        input.remove();
      }
      return;
    }

    const closeButton = event.target.closest('[data-ob-dialog-close]');
    if(closeButton){
      closeDialog(closeButton.closest('dialog'));
      return;
    }

    if(event.target.matches?.('.ob-product-dialog')) closeDialog(event.target);
  });

  function initialise(scope){ updateWishlistButtons(scope || document); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ initialise(document); });
  else initialise(document);
  document.addEventListener('shopify:section:load', function(event){ initialise(event.target); });
  window.addEventListener('storage', function(event){ if(event.key === STORAGE_KEY) updateWishlistButtons(document); });
})();



/* OrbitBay v7.67 Merchant navigation: hero navigation is explicit.
   Only visible CTA links are interactive; the hero surface itself is intentionally inert. */


/* =========================================================
   OrbitBay v7.90 — condition pills deep-link to the exact
   Shopify variant so the matching condition card is selected
   when the shopper lands on the product page.
   ========================================================= */
(function(){
  function openConditionVariant(chip, event){
    if(!chip) return;
    var url = chip.getAttribute('data-obx-condition-link');
    if(!url) return;

    if(event){
      event.preventDefault();
      event.stopPropagation();
    }

    if(event && (event.ctrlKey || event.metaKey)){
      window.open(url, '_blank', 'noopener');
      return;
    }

    window.location.assign(url);
  }

  document.addEventListener('click', function(event){
    var chip = event.target.closest && event.target.closest('[data-obx-condition-link]');
    if(!chip) return;
    openConditionVariant(chip, event);
  });

  document.addEventListener('keydown', function(event){
    if(event.key !== 'Enter' && event.key !== ' ') return;
    var chip = event.target.closest && event.target.closest('[data-obx-condition-link]');
    if(!chip) return;
    openConditionVariant(chip, event);
  });
})();
